import { fetchCommissionsDecoded } from '../client/fetchDecoded'
import persistentStore from '../persistentStore'

/**
 * Creates a campaign service object with methods to interact with campaign-related endpoints.
 *
 * @param {string} baseUrl - The base URL for the API.
 * @param {string} endpoint - The specific endpoint for campaign-related operations.
 * @returns {Object} An object containing methods for campaign operations.
 * 
 * @property {Function} campaignList - Fetches the list of campaigns.
 * @property {Function} campaignList.cancelToken - Optional cancel token to cancel the request.
 * @throws {Error} Throws an error if the request fails.
 */
/**
 * Creates a campaign service object with methods to interact with campaign-related APIs.
 *
 * @param {string} baseUrl - The base URL for the API.
 * @param {string} endpoint - The specific endpoint for campaign-related operations.
 * @returns {Object} An object containing methods for campaign operations.
 * @property {Function} campaignList - Fetches the list of campaigns.
 * @property {Function} campaignList.campaignList - Fetches the list of campaigns.
 * @param {Object} options - Options for the request.
 * @param {Object} options.cancelToken - A token to cancel the request if needed.
 * @throws {Error} Throws an error if the request fails.
 */
const campaignService = (baseUrl, endpoint) => ({
  campaignList: async ({ cancelToken }) => {
    try {
      const data = await fetchCommissionsDecoded(
        `${baseUrl}/${endpoint}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            authorization: persistentStore.getToken(),
            app: process.env.REACT_APP_APPLICATION_NAME
          },
          cancelToken
        }
      )
      return data
    } catch (error) {
      throw error
    }
  }
})

export default campaignService(
  process.env.REACT_APP_API_COMMISIONS_PATH,
  'campaign'
)
